// @ts-ignore
import StringMask from "string-mask";

const cepFormatter = new StringMask("AA.AAA-AAA");

export function formatCep(cep: string) {
  return cepFormatter.apply(cep);
}
